<template>
    <aside class="app-nav-panel">
        <div class="content-wrap">
            <div class="brand">
                <div class="brand-mark">
                    <img src="./../assets/images/logo.png">
                    <span class="brand-version">2.0</span>
                </div>
                <div>
                    <p>World of Warcraft</p>
                    <h1>Raider.io Dashboard</h1>
                </div>
            </div>

            <div class="nav-section">
                <p class="nav-title">Navigation</p>
                <nav class="nav-list" aria-label="Main navigation">
                    <router-link
                        v-for="item in navItems"
                        :key="item.to"
                        :to="item.to"
                        class="nav-item"
                    >
                        <span class="nav-item-icon" aria-hidden="true">
                            <i :class="item.icon"></i>
                        </span>
                        <span class="nav-item-copy">
                            <span class="text">{{ item.label }}</span>
                            <span class="hint">{{ item.hint }}</span>
                        </span>
                    </router-link>
                </nav>
            </div>

            <div class="nav-bottom">
                <div class="nav-section scope-section">
                    <p class="nav-title">Data scope</p>
                    <div class="scope-card">
                        <span>Current season</span>
                        <strong>{{ activeSeasonLabel }}</strong>
                    </div>
                </div>

                <div class="nav-section">
                    <p class="nav-title">Settings</p>
                    <div class="nav-controls">
                        <div class="nav-control-row">
                        <button class="nav-control" type="button" aria-label="Toggle theme" @click="$emit('toggleTheme')">
                            <span>
                                <i v-if="isDarkMode" class="fa-solid fa-sun"></i>
                                <i v-else class="fa-solid fa-moon"></i>
                                Theme
                            </span>
                            <strong>{{ isDarkMode ? 'Dark' : 'Light' }}</strong>
                        </button>
                        <router-link class="nav-control-icon" to="/settings" aria-label="Settings" title="Settings">
                            <i class="fa-solid fa-gear"></i>
                        </router-link>
                        </div>

                        <!-- <button class="nav-control" type="button" aria-label="Check updates" @click="$emit('checkUpdates')">
                            <span>
                                <i class="fa-solid fa-rotate"></i>
                                App status
                            </span>
                            <strong>{{ updateAvailable ? 'Update available' : 'Ready' }}</strong>
                        </button> -->
                    </div>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
export default {
    name: 'AppNavPanel',
    props: {
        navItems: {
            type: Array,
            default() {
                return []
            }
        },
        updateAvailable: {
            type: Boolean,
            default: false
        },
        activeSeasonLabel: {
            type: String,
            default: 'MN1'
        },
        isDarkMode: {
            type: Boolean,
            default: false
        }
    },
    emits: ['toggleTheme', 'checkUpdates']
}
</script>
